import React from 'react';
import { connect } from 'react-redux'
import EventsTable from './eventsTable.component'
import { sortArrayByDate }  from '../../../utils/dateTimeUtils'
import permissions from '../../../utils/permissionsUtils'
import getEventInfo from '../../../actions/events/getEventInfoAction'

class EventsTableContainer extends React.Component {

    handleEventSelected(event) {
        this.props.getEventInfo(event.objectId);
    }

    render() {
        return(
            <div>
                {this.renderCurrentEventsHeader()}
                <EventsTable data={this.getVisibleEvents()}
                             adminPermission={permissions.hasAdminPermission()}
                             ghostMode={permissions.hasViboAdminPermission()}
                             handleEventSelected={this.handleEventSelected.bind(this)}
                />
            </div>
        );
    }

    renderCurrentEventsHeader(){
        let currentEventsNumber = this.getVisibleEvents().length;
        let currentEventsDisplay = `You have ${currentEventsNumber} upcoming event${currentEventsNumber===1 ? '' : 's'}`;
        let pastEventsDisplay = `You had ${currentEventsNumber} past event${currentEventsNumber===1 ? '' : 's'}`;
        return this.props.showActive ? <h1>{currentEventsDisplay}</h1> : <h1>{pastEventsDisplay}</h1>;
    }

    getVisibleEvents() {
        let dateOffset = (24*60*60*1000) * 1; //date offset of one day so events won't display in past events until a full 24 hours after the event's start time
        let now = new Date()-dateOffset;
        let filteredByDateEvents =
            this.props.data.filter((event) => {return this.props.showActive ? event.start >= now : event.start < now});
        return sortArrayByDate(filteredByDateEvents, 'start', !this.props.showActive);
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.events.data
    };
};

const mapDispatchToProps = {
    getEventInfo: getEventInfo
};


export default connect(
    mapStateToProps, mapDispatchToProps
)(EventsTableContainer)



// WEBPACK FOOTER //
// ./src/pages/myEvents/eventsTable/eventsTable.container.js